import sanitizeFn from 'sanitize-filename'

export const sanitizeFilename = sanitizeFn
